import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Other: React.FC<IconProps> = ({
                                                  fill = COLORS.FG.SOFT,
                                                  width = 24,
                                                  height = 24,
                                                  className,
                                              }) => {
    return (
        <svg viewBox="0 0 24 24" className={className} xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Navigation / More" width="24.000000" height="24.000000" x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5ZM3 7.5C3 8.32843 2.32843 9 1.5 9C0.671573 9 0 8.32843 0 7.5C0 6.67157 0.671573 6 1.5 6C2.32843 6 3 6.67157 3 7.5ZM1.5 15C2.32843 15 3 14.3284 3 13.5C3 12.6716 2.32843 12 1.5 12C0.671573 12 0 12.6716 0 13.5C0 14.3284 0.671573 15 1.5 15Z"
                  fill={fill} fillRule="evenodd"
                  transform="matrix(-4.37114e-08,1,-1,-4.37114e-08,19.5,10.5)"/>
        </svg>

    );
};
